<!-- 用户管理 -->
<template>
  <div class="diseaseList">
    <!-- 顶部操作栏：手机号 / openid 两组搜索，与表格拼接成整块白卡 -->
    <div class="action-bar">
      <div class="action-left">
        <div class="search-group">
          <el-input
            class="search-input"
            v-model="listQuery.phone"
            placeholder="搜索手机号"
            prefix-icon="el-icon-mobile-phone"
            size="small"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
          <el-button class="btn-search" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </div>
        <div class="search-group">
          <el-input
            class="search-input search-input--wide"
            v-model="listQuery.openid"
            placeholder="搜索 openid"
            prefix-icon="el-icon-user"
            size="small"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
          <el-button class="btn-search" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="action-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 位用户
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="disable" slot-scope="{ row }">
          <span class="user-chip" :class="row.disable === 1 ? 'abnormal' : 'normal'">
            {{ row.disable === 1 ? "异常用户" : "正常用户" }}
          </span>
        </template>
        <template slot="openid" slot-scope="{ row }">
          <el-tooltip
            :content="row.openid"
            placement="top"
            :disabled="!row.openid"
          >
            <span class="cell-text">{{ row.openid || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" class="op-edit" @click="handleDisable(row)">{{
              row.disable === 1 ? "启用" : "禁用"
            }}</el-button>
            <el-button size="mini" class="op-delete" @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { selectUser, disableUser } from "@/services/plus/user";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        phone: "",
        openid: "",
      },
      /* 表格数据 */
      tableData: [],
    };
  },
  computed: {
    listHeader,
  },
  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectUser(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索：回到第 1 页 */
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 启用 / 禁用 */
    handleDisable(row) {
      const action = row.disable === 1 ? "启用" : "禁用";
      this.$confirm(
        `确定${action}手机号为"${row.phone}"的用户吗?`,
        `${action}用户`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          disableUser({ id: row.id, disable: row.disable === 1 ? 0 : 1 }).then(
            (res) => {
              if (res.code === 200) {
                this.getListData();
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    /* 删除：接口暂未开放，保留入口 */
    handleDelete() {},
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 顶部操作栏：白卡上半部，与表格拼接 */
.action-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .action-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  /* 输入框与搜索按钮拼接成一体，弱化次要操作 */
  .search-group {
    display: flex;
    align-items: center;

    /deep/ .search-input .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 6px 0 0 6px;
    }
    .btn-search {
      height: 32px;
      margin-left: -1px;
      padding: 0 16px;
      font-size: 14px;
      color: #3d8dfc;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 0 6px 6px 0;
      transition: all 0.2s;

      &:hover {
        color: #2f7be0;
        background: #f3f8ff;
        border-color: #3d8dfc;
        position: relative;
        z-index: 1;
      }
    }
  }
  .search-input {
    width: 200px;
  }
  .search-input--wide {
    width: 240px;
  }

  /* 右侧统计信息，平衡一行视觉重心 */
  .action-meta {
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

/* 用户状态：浅色底小标签 */
.user-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;

  &.normal {
    background: #e8f8ee;
    color: #00b42a;
  }
  &.abnormal {
    background: #fdecee;
    color: #f53f3f;
  }
}

/* 操作列：启用/禁用蓝字 / 删除红字 */
.operation {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-button {
    margin: 0;
    padding: 0 8px;
    height: 24px;
    line-height: 1;
    font-size: 13px;
    border: none;
    background: transparent;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease;
  }
  .op-edit {
    color: #3d8dfc;

    &:hover {
      color: #2f7be0;
    }
  }
  .op-delete {
    color: #f53f3f;
    border-left: 1px solid #e5e6eb;
    margin-left: 6px;
    padding-left: 14px;

    &:hover {
      color: #ff7875;
    }
  }
}
</style>
